module.exports = __webpack_public_path__ + "10de31607e2027fd1ccce9c6fcbec5f2.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/RobotoCondensed-Light.ttf
// module id = 506
// module chunks = 0